import { render, staticRenderFns } from "./EditAffiliation.vue?vue&type=template&id=5e53cb32&scoped=true"
import script from "./EditAffiliation.vue?vue&type=script&lang=js"
export * from "./EditAffiliation.vue?vue&type=script&lang=js"
import style0 from "./EditAffiliation.vue?vue&type=style&index=0&id=5e53cb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53cb32",
  null
  
)

export default component.exports